import { Directory } from "@capacitor/filesystem";
import { AWSService } from "../controllers/AWSService";
import { AWSAccessParams, EvidenceAttachment } from "../types/Interfaces";
import { Utils } from "./utils";
import WriteBlob from "capacitor-blob-writer";
import mime from "mime";
import { FileOpener } from "@capacitor-community/file-opener";

export namespace FileUtils {
  export async function viewAttachment(
    token: string,
    contactID: string,
    evidenceContactID: string,
    evidenceID: string,
    attachment: EvidenceAttachment
  ) {
    try {
      const accessParams: AWSAccessParams = await AWSService.generateSTSToken(token, contactID);
      const file = await AWSService.openAttachmentFromServer(
        token,
        contactID,
        accessParams,
        evidenceContactID,
        evidenceID,
        attachment
      );

      let isMSGFile = attachment.name.endsWith(".msg");

      if (await Utils.isWebAsync()) {
        let url;

        if (isMSGFile) {
          url = window.URL.createObjectURL(
            new Blob([new Uint8Array(file.Body.data)], {
              type: "application/vnd.ms-outlook",
            })
          );

          var a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = url;
          a.download = attachment.name;
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          url = window.URL.createObjectURL(
            new Blob([new Uint8Array(file.Body.data)], {
              type: file.ContentType,
            })
          );

          window.open(url, "_blank");
        }
      } else {
        const blob = new Blob([new Uint8Array(file.Body.data)], {
          type: file.ContentType,
        });

        const filePath = await WriteBlob({
          path: `ParaFolio/Attachments/${attachment.name}.${isMSGFile ? "msg" : mime.getExtension(file.ContentType)}`,
          blob,
          directory: Directory.Library,
          recursive: true,
        });

        console.log("Wrote file to:", filePath);

        FileOpener.open({
          filePath,
        });
      }
    } catch (error) {
      throw error;
    }
  }
}
